import {
  Checkbox,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material';
import { getMetricFieldName, getMetricUnits } from '../../utils/metricHelpers';
import { Control, Controller, useFieldArray } from 'react-hook-form';
import { IFormReportCreation } from '../creationSection/FormFirstStepReportCreation';
import { useLingui } from '@lingui/react';
import { MetricField } from 'src/__generated__/graphql';

const hasSelectableUnit = (field: MetricField) =>
  getMetricUnits(field).some((unit) => unit.label !== '');

const MetricsUnitSelector = (props: { control: Control<IFormReportCreation> }) => {
  const { control } = props;
  const { fields } = useFieldArray({ control: control, name: 'metrics' });
  const { i18n } = useLingui();
  return (
    <List dense>
      <Grid container spacing={2}>
        {fields.map((metric, index) => (
          <Grid item xs={12} md={6} xl={4} key={metric.field}>
            <Controller
              name={`metrics.${index}.use`}
              control={control}
              render={({ field: { onChange, value } }) => (
                <ListItemButton onClick={() => onChange(!value)}>
                  <Checkbox
                    checked={Boolean(value)}
                    edge="start"
                    onChange={(e) => onChange(e.target.checked)}
                  />
                  {hasSelectableUnit(metric.field) && (
                    <Controller
                      control={control}
                      name={`metrics.${index}.unit`}
                      render={({ field: { onChange: onChangeUnit, value: unitValue } }) => (
                        <Select
                          size="small"
                          value={unitValue}
                          onChange={(e) => {
                            onChangeUnit(e);
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                          }}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                          }}
                        >
                          {getMetricUnits(metric.field).map((unit) => (
                            <MenuItem key={unit.value} value={unit.enum}>
                              {unit.label}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  )}
                  <ListItemText sx={{ ml: 2 }} primary={getMetricFieldName(i18n, metric.field)} />
                </ListItemButton>
              )}
            />
          </Grid>
        ))}
      </Grid>
    </List>
  );
};

export { MetricsUnitSelector };
